export const pickTier = (entry, mwhc) => {
  if (!entry) return null;
  const base = { min_mwhc: 0, cee_price: entry.cee_price, cee_price_precaire: entry.cee_price_precaire ?? null };
  return (entry.tiers || []).reduce((acc, t) => (mwhc >= t.min_mwhc ? t : acc), base);
};

export const tierLabel = (entry, tier) => {
  const tiers = entry?.tiers || [];
  if (!tiers.length) return null;
  const next = [{ min_mwhc: 0 }, ...tiers].find((t) => t.min_mwhc > tier.min_mwhc);
  const fmt = (v) => Number(v).toLocaleString("fr-FR");
  return next ? `${fmt(tier.min_mwhc)} – ${fmt(next.min_mwhc)} MWhc` : `≥ ${fmt(tier.min_mwhc)} MWhc`;
};
